<div
  class="w-[19rem] h-[16.375rem] gap-4 flex flex-col items-center justify-center">
  <div class="c1 text-gray-800 text-center w-full">{{ options.title }}</div>
  <div class="h-[13.375rem] relative flex flex-col items-center">
    <div
      class="left-bracket-position left-bracket w-[0.375rem] h-[13.375rem] absolute border-solid border-blue-400"></div>

    <div class="right-bracket-position gap-1 h-full flex flex-col absolute">
      <div
        class="w-[0.375rem] border-solid right-bracket"
        [ngClass]="difference > 0 ? 'border-orange-300' : 'border-gray-500'"
        [style.height.%]="rightTopSectionHeight"></div>
      <div
        class="w-[0.375rem] border-solid right-bracket border-blue-400"
        [style.height.%]="rightBottomSectionHeight"></div>
    </div>

    <div
      class="w-[4.375rem] rounded-[0.375rem] overflow-hidden gap-1 h-full flex flex-col">
      @if (difference > 0) {
        <div
          class="flex items-center justify-center bg-orange-300 c2 text-gray-000"
          [style.height.%]="rightTopSectionHeight">
          {{ topValue | number }}
        </div>
      } @else {
        <div
          class="flex items-center justify-center border-dashed border-2 border-gray-500"
          [style.height.%]="rightTopSectionHeight"></div>
      }

      <div
        class="flex items-center justify-center bg-blue-300 c2 text-blue-700"
        [style.height.%]="rightBottomSectionHeight">
        {{ bottomValue | number }}
      </div>
    </div>

    <div
      class="absolute left-label-position flex flex-wrap justify-center items-center c1 text-gray-800 h-full max-w-[4.44rem]"
      [innerHTML]="leftLabel"></div>
    <div
      class="absolute right-label-position c1 text-gray-800 max-w-[4.44rem]"
      [style.top.%]="rightTopLabelPosition"
      [innerHTML]="rightTopLabel"></div>
    <div
      class="absolute right-label-position c1 text-gray-800 max-w-[4.44rem]"
      [style.top.%]="rightBottomLabelPosition"
      [innerHTML]="rightBottomLabel"></div>
  </div>
</div>
